import { Injectable } from "@angular/core";
import { ProfileDataService } from "@mol-limo-reg/admin-api";
import { Observable } from "rxjs";
import { Admin } from "@mol-limo-reg/admin-api/model/models";

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(private readonly profileDataService: ProfileDataService) {}

  public getProfile$(): Observable<Admin> {
    return this.profileDataService.getProfile('body');
  }
}
